import { DocumentIcon, RemoveIcon } from "Assets/icons";
import { Button } from "react-bootstrap";
import LoadingIndicator from "../LoadingIndicator";
import { useState } from "react";
import { CommonToolTip } from "components/Common/Common";

const SingleUploadedFileDetail = ({ value, handleRemoveFile, preview }) => {
  const [isLoading, setLoading] = useState(false);
  return (
    <li className="d-flex align-items-center gap-10">
      {preview ? (<img src={value} className='w-100' height={200} />) : (<div className="left d-flex align-items-center">
        <span className="icn me-2">
          <DocumentIcon />
        </span>
        {/* <p className="m-0 text-muted">{value}</p> */}
        <CommonToolTip
          component={<p className="m-0 text-muted">
            {value?.length > 40 ? `${value.slice(0, 40)}...` : value}
          </p>}
          text={value}
        />
      </div>)}
      <Button
        className="border-0 p-0"
        variant={"transparent"}
        onClick={() => {
          handleRemoveFile(setLoading)
        }}
      >
        <RemoveIcon />
      </Button>
      {isLoading && (
        <span>
          <LoadingIndicator inline={true} />
        </span>
      )}
    </li>
  )
}

export default SingleUploadedFileDetail;